// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7e82b24a] .settings-tab-wrapper a.active{background-color:rgba(0,0,0,0) !important;border-color:#ccc !important;box-shadow:inset 0 3px 5px rgba(0,0,0,.3) !important}", ""]);
// Exports
module.exports = exports;
